import { useDefinition } from "./useDefinition";
import { useSupportedProductStartDate } from "./useSupportedProductStartDate";

export const useProductStartDate = (): eXpress.DateMonthString | undefined => {
	const definition = useDefinition();
	const supportedStartDate = useSupportedProductStartDate();

	if (!supportedStartDate) return undefined;

	return definition?.startMonth;
};
